import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark1Small: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCheckmark1Small"><Path fillRule="evenodd" clipRule="evenodd" d="M16.765 7.07607C16.9992 7.22242 17.0704 7.5309 16.924 7.76507L11.299 16.7651C11.2182 16.8943 11.083 16.9796 10.9316 16.9969C10.7802 17.0141 10.6292 16.9614 10.5214 16.8536L7.14645 13.4786C6.95118 13.2834 6.95118 12.9668 7.14645 12.7715C7.34171 12.5763 7.65829 12.5763 7.85355 12.7715L10.7841 15.7021L16.076 7.23507C16.2224 7.0009 16.5308 6.92971 16.765 7.07607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark1Small;
